export default "__VITE_ASSET__ILnzevGC__"